module.exports = __webpack_public_path__ + "img/error-arrow.2783b5ba.svg";